const SearchIconBtn = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6269 13.2847H12.1832L15.2464 18.5902L16.3291 17.9652L13.6269 13.2847ZM3.67166 7.03467C3.67166 10.1362 6.19516 12.6597 9.29666 12.6597C12.3982 12.6597 14.9217 10.1362 14.9217 7.03467C14.9217 3.93317 12.3982 1.40967 9.29666 1.40967C6.19516 1.40967 3.67166 3.93317 3.67166 7.03467ZM4.92166 7.03467C4.92166 4.62223 6.88454 2.65967 9.29666 2.65967C11.7088 2.65967 13.6717 4.62223 13.6717 7.03467C13.6717 9.44711 11.7088 11.4097 9.29666 11.4097C6.88454 11.4097 4.92166 9.44711 4.92166 7.03467Z"
        fill="#111113"
      />
    </svg>
  )
}

export default SearchIconBtn
